"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// noinspection SpellCheckingInspection
const tweetnacl_1 = __importDefault(require("tweetnacl"));
const tweetnacl_util_1 = __importDefault(require("tweetnacl-util"));
const AuthenticatedUser_1 = require("../models/AuthenticatedUser");
const Signature_1 = require("../models/Signature");
class CryptoService {
    constructor(transactionTypeResolver) {
        this.hashLength = 16;
        this.transactionTypeResolver = transactionTypeResolver;
    }
    getUserByLoginAndPassword(login, password) {
        const seed = password + login;
        const pair = CryptoService.getPairBySeed(seed);
        return new AuthenticatedUser_1.AuthenticatedUser(login, tweetnacl_util_1.default.encodeBase64(pair.publicKey), tweetnacl_util_1.default.encodeBase64(pair.secretKey));
    }
    calculateTransactionHash(creator, type, model) {
        const payloadSerializer = this.transactionTypeResolver.getPayloadSerializer(type);
        const modelPayload = payloadSerializer.modelToPayload(model, false);
        const str = JSON.stringify([creator, type, modelPayload]);
        const hash = tweetnacl_1.default.hash(tweetnacl_util_1.default.decodeUTF8(str));
        const shortHash = hash.slice(0, Math.min(this.hashLength, 32));
        return tweetnacl_util_1.default.encodeBase64(shortHash);
    }
    signTransaction(user, tx) {
        const signatureData = tweetnacl_1.default.sign.detached(tweetnacl_util_1.default.decodeBase64(tx.hash), tweetnacl_util_1.default.decodeBase64(user.privateKey));
        const signatureStr = tweetnacl_util_1.default.encodeBase64(signatureData);
        const signature = new Signature_1.Signature(signatureStr, user.publicKey);
        tx.signatures.push(signature);
        return tx;
    }
    verifySignature(tx, signature) {
        return tweetnacl_1.default.sign.detached.verify(tweetnacl_util_1.default.decodeBase64(tx.hash), tweetnacl_util_1.default.decodeBase64(signature.signature), tweetnacl_util_1.default.decodeBase64(signature.publicKey));
    }
    static getPairBySeed(seed) {
        const seedArray = tweetnacl_util_1.default.decodeUTF8(seed);
        // Padding to length of 32
        const seedArray32 = new Uint8Array(32);
        for (let i = 0; i < 32; i++) {
            if (i + 1 <= seedArray.length) {
                seedArray32[i] = seedArray[i];
            }
            else {
                seedArray32[i] = 1;
            }
        }
        return tweetnacl_1.default.sign.keyPair.fromSeed(seedArray32);
    }
}
exports.CryptoService = CryptoService;
